import { Card } from '@/design-system';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getCitySeoByPath, getCitySeoBySlug } from '../../../../seo/citySeo';

const CitySeoContent = () => {
  const { municipality } = useParams();
  const location = useLocation();

  const seo = useMemo(() => {
    const byPath = getCitySeoByPath(location.pathname);
    if (byPath) return byPath;
    if (!municipality) return null;
    return getCitySeoBySlug(municipality, 'NOR');
  }, [location.pathname, municipality]);

  if (!seo?.body?.length) return null;

  return (
    <div style={{ padding: '0px 12px', marginBottom: 24 }}>
      <Card aria-labelledby="city-seo-heading">
        {seo.heading && (
          <h2 id="city-seo-heading" style={{ marginTop: 0 }}>
            {seo.heading}
          </h2>
        )}
        {seo.body.map((paragraph, index) => (
          <p key={index} style={{ fontSize: 14, color: 'var(--muted)', marginBottom: 0 }}>
            {paragraph}
          </p>
        ))}
      </Card>
    </div>
  );
};

export default CitySeoContent;
